import angular from 'angular';
import openRequestsDataServiceFactory from '../Components/openRequests/openRequestsDataService.factory';
import approvalRulesDataServiceFactory from '../Components/ApprovalRules/approvalRulesDataService.factory';

export default angular
    .module('app.identityManager.factories', [])
    .factory('openRequestsDataService', openRequestsDataServiceFactory)
    .factory('approvalRulesDataService', approvalRulesDataServiceFactory)
    .name;